import Tiptap from '../../../components/Tiptap/Tiptap';
import { useEffect } from 'react';

import { useQuery } from '@apollo/client';
import {
  BorderedSection,
  Button,
  Loading,
  QuickEdit,
} from '../../../components';
import { FETCH_PROCESSES_AREAS_WITH_STRATEGY_BY_LOCATION } from '../../dataInputs/queries/processAreas';
import { useParams } from 'react-router';
import { findObjectByKey } from '../../bcp/strategies/strategyReview/utils';
import QueryErrorBoundary from '../../../components/error-handling';
import {
  EMPTY_COMMENTARY_TEXT,
  EMPTY_SUMMARY_EXPRESSIONS,
} from '../../bcp/strategies/StrategyComponents/constants';

interface CommentaryProps {
  mitigationType: string;
  processId: string;
  getComment: (comment: string) => void;
  updateStrategyId: (strategyId: string) => void;
  onEdit: () => void;
}

type FindProcessAreaByUuid = {
  comment: string;
  processArea: string;
  replacementCost: number;
  replacementTime: number;
  strategyComment: string;
  underlyingProcesses: string;
  uuid: string;
};

type FindProcessesByUuid = {
  comment: string;
  process: string;
  replacementCost: number;
  replacementTime: number;
  strategyComment: string;
  uuid: string;
};

interface DataReturned {
  findProcessAreaByUuid?: FindProcessAreaByUuid;
  findProcessesByUuid?: FindProcessesByUuid;
}

export function Commentary({
  mitigationType,
  processId,
  getComment,
  updateStrategyId,
  onEdit,
}: CommentaryProps) {
  const params = useParams();
  const locationId = params.locationId!;
  const mutation = FETCH_PROCESSES_AREAS_WITH_STRATEGY_BY_LOCATION;

  const { data, loading, error } = useQuery(mutation, {
    variables: {
      uuid: locationId,
    },
  });

  const processAreaData = findObjectByKey(data?.findAll || [], processId);

  const actualComment = processAreaData?.strategy?.summary;

  const includeEmptyExpressions =
    !actualComment ||
    EMPTY_SUMMARY_EXPRESSIONS.includes(actualComment?.split(' ')?.join(''));

  const summaryText = includeEmptyExpressions
    ? 'Add commentary...'
    : actualComment;

  useEffect(() => {
    getComment(actualComment);
    updateStrategyId(processAreaData?.strategy?.uuid!);
  }, [data]);

  if (loading) return <Loading />;

  return (
    <QueryErrorBoundary error={error}>
      <BorderedSection title="Mitigation Strategy Commentary">
        <div className="flex h-full">
          {!loading ? (
            <>
              <div
                className={`tiptap w-full ${
                  summaryText === EMPTY_COMMENTARY_TEXT
                    ? 'text-primary-300 opacity-60'
                    : ''
                }`}
                dangerouslySetInnerHTML={{ __html: summaryText }}
              />
              <Button type="edit" onClick={onEdit}>
                <QuickEdit />
              </Button>
            </>
          ) : (
            <Loading />
          )}
        </div>
      </BorderedSection>
    </QueryErrorBoundary>
  );
}
